import { jsx as _jsx } from "react/jsx-runtime";
import hoistStatics from 'hoist-non-react-statics';
import { useLocation, useNavigate, useParams, } from 'react-router-dom';
export function withRouter(Component) {
    const displayName = `withRouter(${Component.displayName || Component.name})`;
    const C = (props) => {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();
        return (_jsx(Component, Object.assign({ location: location, navigate: navigate, params: params }, props)));
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return hoistStatics(C, Component);
}
